import React from 'react'
import { ReactComponent as EmptyAudience } from './../../images/emptyStates/first_audience.svg'
import AddCustomersForm from '../../forms/AddCustomers'
import { Button } from '@demandlocal/components'
import { useNavigate } from 'react-router'
import { useDealership } from '../../store/zustand/dealershipStore'
import { useTranslation } from 'react-i18next'
import { useModal } from '../useModal'
const GetSalesMatchback = (): JSX.Element => {
  const { t } = useTranslation('routes')
  const { handleModal } = useModal()
  const dealership = useDealership()
  const navigate = useNavigate()
  return (
    <div className={'flex flex-col gap-2 font-Spartan'}>
      <div
        className={
          'flex flex-row gap-2 border-2 border-dashed rounded-md justify-between items-center p-5'
        }>
        <div className={'flex flex-row gap-2 items-center'}>
          <EmptyAudience />
          <div className={'flex flex-col gap-1 px-5 w-full ml-0'}>
            <span className={'font-bold text-lg'}>See what cars sold!</span>
            <span className={'font-medium test-sm'}>
              Connect your DMS to see how many sold vehicles were attributed to your
              marketing campaigns
            </span>
          </div>
        </div>
        <Button
          variant={'secondary'}
          onClick={() => {
            navigate(`${t('dealership.customers.sources.create', { dealership })}/sales`)
          }}>
          + Connect your DMS
        </Button>
      </div>
    </div>
  )
}

export default GetSalesMatchback
